import {calculateTotalPayConsideringCapReductionBonus} from "./helpers/helpers";

export function formatMoney(value = 0, withCents = false, showDashForZero = true) {
  if (!value) value = 0

  // A division with no denominator (per stop of a week with 0 stops) gives Infinity,
  // which Intl.NumberFormat renders as "$∞". There is no amount to show in that case.
  if (!Number.isFinite(Number(value))) value = 0

  if((Number(value) === 0 ||value === 0) && showDashForZero){
    return '-'
  }

  const res =  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: withCents || value === 0 ? 2 : 0,
    minimumFractionDigits: withCents || value === 0 ? 2 : 0
  }).format(value)

  return String(res)
}

export function formatNegativeMoney(value = 0, withCents = false, showDashForZero = true) {
  const negativeValue = -Math.abs(Number(value) || 0)
  return formatMoney(negativeValue, withCents, showDashForZero)
}

export function formatNumber(value = 0) {
  if(value === 0){
    return '-'
  }
  return String(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
}

export function formatPercentage(value = 0) {
  if (!value || value == 0) {
    return "-"
  }
  return `${value} %`
}

export function formatMilesPerGalon(miles = 0, fuel = 0) {
  const m = Number(miles) || 0
  const f = Number(fuel) || 0
  if (!m || !f) {
    return "-"
  }
  return (m / f).toFixed(2)
}

export function calculateTotalPayAndPerStop(weeklySummary, stationId, newEmployee, totalFuel) {
  const {
    addition = 0,
    deduction = 0,
    pto = 0,
    employee,
    total_hours,
    total_w2 = 0,
    total_stops = 0,
    total_fuel = 0,
    training_days = 0,
    is_hours_disabled,
    total_wa_hourly,
    added_bonus,
    added_deduction_bonus,
    six_day_bonus,
    sunday_bonus,
    saturday_bonus,
    safety_bonus,
    is_contingency,
    contingencyCalculatedHourAfterManualHours
  } = weeklySummary
  const curEmployee = newEmployee || employee || {}
  const curTotalFuel = totalFuel || total_fuel || {}
  const { rates } = curEmployee
  const isWeekly = Boolean(rates?.weekly_rate_w2) && rates?.adding_daily_pay === 0
  const { paid_time_off = 0, hourly_rate = 0, training_rate = 0 } = rates || {}
  const isOvertime = curEmployee?.rates?.is_overtime_enabled && +total_hours > 40
  let calculatedHour = 0;

  if (is_contingency) {
    calculatedHour = 0;

    if (contingencyCalculatedHourAfterManualHours > 0) {
      calculatedHour = contingencyCalculatedHourAfterManualHours
    } else {
      const employeeDailySummaries = curEmployee?.daily_summaries?.filter(summary => summary.statement_id === weeklySummary?.statement_id) || [];

      employeeDailySummaries.forEach((daily) => {
        let employeeRates = {};

        if (daily?.is_contingency) {
          employeeRates = curEmployee?.contingency_rates
        } else {
          employeeRates = curEmployee?.rates
        }

        if (employeeRates?.subtracting_daily_pay) {
          return;
        }

        const hourlyRate = employeeRates?.hourly_rate || 0;
        const hours = daily?.hours || 0;

        calculatedHour += hours * hourlyRate;
      });
    }
  } else {
    const employeeDailySummaries = curEmployee?.daily_summaries?.filter(summary => summary.statement_id === weeklySummary?.statement_id);

    if (rates?.is_daily_overtime_enabled && employeeDailySummaries?.some(summary => summary.hours > 8)) {
      if (rates?.is_work_area_enabled === 1) {
        calculatedHour = total_wa_hourly
      } else {
        employeeDailySummaries.forEach((daily) => {
          const hours = daily?.hours

          if (hours > 8) {
            const overtimeHours = hours - 8
            const overtimeHourlyRate = rates.hourly_rate * 1.5

            calculatedHour += (8 * rates.hourly_rate) + (overtimeHours * overtimeHourlyRate)
          } else {
            calculatedHour += rates.hourly_rate * hours
          }
        })
      }
    } else {
      calculatedHour = rates?.subtracting_daily_pay
          ? 0
          : is_hours_disabled === 1
              ? total_wa_hourly
              : isOvertime
                  ? 40 * rates.hourly_rate + (+total_hours - 40) * (1.5 * rates.hourly_rate)
                  : total_hours * hourly_rate
    }
  }

  const isNotNativeCompany = stationId !== curEmployee.station?.id
  const trainingDaysPay = +training_days * +training_rate

  let elTotalPay =
    !isWeekly && !isNotNativeCompany
      ? total_w2 + +addition - +deduction + pto * paid_time_off + Number(calculatedHour) + trainingDaysPay
      : total_w2 +
        +addition -
        +deduction +
        Number(calculatedHour) +
        (!isWeekly && isNotNativeCompany ? trainingDaysPay : 0)

  elTotalPay = calculateTotalPayConsideringCapReductionBonus(rates, Number(calculatedHour), total_w2, added_bonus, added_deduction_bonus, six_day_bonus, sunday_bonus, saturday_bonus, elTotalPay, safety_bonus)

  const perStop =
      +total_stops > 0 && +elTotalPay > 0 ? (+elTotalPay + +curTotalFuel) / +total_stops : 0

  return { elTotalPay, perStop }
}

export function calculateProfit(totalW2, data, source) {
  let total_fuel = 0;

  if (source === "payroll") {
    total_fuel = data.file_total_fuel === 0 ? 0 : +data.total_fuel + +data.missed_fuel_diff;
  }

  if (source === "statement") {
    total_fuel = +data.total_fuel;
  }

  const profit = +data.total_charges - +totalW2 - +data.total_expenses - +total_fuel

  return profit + Number(data?.chargebacks_and_deductions_total)
}
